export default __webpack_public_path__ + "static/scyrg-white-3172dbc64042127628cbf1027b9ae10c.png";